import { Skeleton } from '@heroui/react';

export const ProductDescription = ({
  text,
  isLoading = false,
}: {
  text: string;
  isLoading?: boolean;
}) => {
  return (
    <Skeleton isLoaded={!isLoading} className="rounded-md">
      <p className="text-xs text-[#9CA5AC] h-4 break-all line-clamp-1 overflow-ellipsis">
        {text}
      </p>
    </Skeleton>
  );
};
